module.exports = __webpack_public_path__ + "img/blog-card-img.eaee4e31.png";